import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LatestTalentService {
private API_URL= environment.API_URL;

  constructor(private http: HttpClient) {}

  getLatestTalent(){
    let url = `${this.API_URL}/afrotech-talents?populate=*&sort=publishedAt:desc&pagination[limit]=1`;

    return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
}
}
